import React, { useEffect, useState, useContext } from 'react'
import { constants, useServices, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import AceHighwayManifestKeys from 'src/constants/locale/key/AceHighwayManifest'
import AceHighwayManifestApiUrls from 'src/apiUrls/AceHighwayManifestApiUrls'
import CngSection from '../../../../components/cngcomponents/CngSection'
import moment from 'moment'
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core'
import clsx from 'clsx'
import {FileForUserGetPartyId } from 'src/common/FileForUserCommon'
import ACEHighwayManifestTranslationText from '../../contexts/ACEHighwayManifestTranslationText'

const {
  filter: { EQUAL }
} = constants

const useStyles = makeStyles((theme) => ({
  table: {
    '& .MuiTableHead-root': {
      backgroundColor: theme.palette.background.sectionOddBg,
      '& .MuiTableCell-head': {
        borderBottom: 0,
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1.2,
        textTransform: 'uppercase'
      }
    },
    '& .MuiTableBody-root': {
      '& .MuiTableRow-root': {
        '&:last-child': {
          '& .MuiTableCell-root': {
            borderBottom: 0
          }
        }
      }
    },
    '& .MuiTableCell-root': {
      padding: '8px 16px'
    }
  }
}))

function History(props) {
  const { manifestId } = props

  const [data, setData] = useState([])
  const classes = useStyles()
  const { fetchRecords } = useServices()
  const aceHighwayManifestTranslationText = ACEHighwayManifestTranslationText() 
  //const { translate } = useTranslation([Namespace.ACE_HIGHWAY_MANIFEST])
  //const translatedTextsObject = makeTranslatedTextsObject()

  useEffect(() => {
    fetchRecords.execute(
      AceHighwayManifestApiUrls.GET_AUDIT_LOGS,
      {
        filters: [
          {
            field: 'keyReferenceNo',
            operator: EQUAL,
            value: 'ACE_HIGHWAY_MANIFEST_' + manifestId
          },
          {
            field: 'partyId',
            operator: EQUAL,
            value: FileForUserGetPartyId()
          }
        ]
      },
      (res) => {
        setData(res.content)
      }
    )
  }, [])

  /*function makeTranslatedTextsObject() {
    let createdDate = translate(
      Namespace.ACE_HIGHWAY_MANIFEST,
      AceHighwayManifestKeys.CREATED_DATE_TIME
    )
    let loginUserId = translate(
      Namespace.ACE_HIGHWAY_MANIFEST,
      AceHighwayManifestKeys.LOGIN_USER_ID
    )
    let functionCode = translate(
      Namespace.ACE_HIGHWAY_MANIFEST,
      AceHighwayManifestKeys.FUNCTION_CODE
    )
    let auditDescription = translate(
      Namespace.ACE_HIGHWAY_MANIFEST,
      AceHighwayManifestKeys.AUDIT_DESC
    )

    return {
      createdDate,
      loginUserId,
      functionCode,
      auditDescription
    }
  }*/

  const columns = [
    { field: 'functionCode', title: aceHighwayManifestTranslationText.functionCode },
    {
      field: 'auditDescription',
      title: aceHighwayManifestTranslationText.auditDescription
    },
    {
      title: 'Account',
      render: (data) => (
        <div>
          <Typography>{aceHighwayManifestTranslationText.accountNameAndOr}</Typography>
          <Typography variant='body2' color='textSecondary'>
            {data.userName}
          </Typography>
        </div>
      )
    },
    {
      title: aceHighwayManifestTranslationText.createdDate,
      render: (data) =>
        data.createdDate &&
        moment(data.createdDate).format('D MMM YYYY - HH:mm')
    }
  ]

  return (
    <CngSection title='History'>
      <TableContainer className='new-ui-table-component'>
        <Table className={clsx(classes.table, 'new-ui-table-component__table')}>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell key={index}>{column.title}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? (
              data.map((d) => (
                <TableRow key={d.id}>
                  {columns.map((column, index) => (
                    <TableCell key={index}>
                      {column.render ? column.render(d) : d[column.field]}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell align='center' colSpan={columns.length}>
                  <Typography variant='body2' color='textSecondary'>
                    {aceHighwayManifestTranslationText.noRecorsToDisplay}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </CngSection>
  )
}

export default History
